import { useMutation } from '@tanstack/react-query'
import { updateBonusLimit } from 'api/payment'
import { useAuthContext } from 'components/auth'

interface UseUpdateBonusLimitMutation {
  onSuccess?: () => void
  onError?: (err: Error) => void
}

export function useUpdateBonusLimitMutation(
  options?: UseUpdateBonusLimitMutation
) {
  const { company } = useAuthContext()

  return useMutation({
    mutationFn: async (limit: number) => {
      if (!company?.id) {
        throw new Error('Company id not found')
      }
      return updateBonusLimit(company.id, limit)
    },
    ...options,
  })
}
